


























































































































import {
    computed,
    defineComponent,
    onMounted,
    onBeforeUnmount,
    PropType,
    ref,
    nextTick,
} from '@vue/composition-api';
import {
    SdsAlert,
    SdsButton,
    SdsInputCurrency,
    SdsTypeSwitcher,
    TypeItem,
} from '@superbet-group/web.lib.ui-components';
import DepositLimitsProgress from '@walletFederation/src/ui/deposit/components/DepositLimitsProgress.vue';
import { getConfig } from '@superbet-group/web.lib.config';
import {
    loadScript,
    addMinutes,
    ValidationError,
    isRequired,
} from '@superbet-group/web.lib.utilities';
import { UserService } from '@core/services/user/UserService';
import { RouteName } from '@src/app/router/constants/RouteName';
import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
import {
    useVueRouter,
    useVuexStore,
    useI18n,
    isMobileLayout,
} from '@superbet-group/web.lib.vue-utilities';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    min,
    max,
} from '@modules/shared/validators/forms';
import { errorGuard } from '@utils/ErrorGuard';
import LimitError from '@core/errors/user/LimitError';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import { LimitsStore } from '@store/modules/limits/limitsIndex';
import errorIndex from '@store/modules/errors/errorIndex';
import countryIndex from '@store/modules/data/country/countryIndex';
import PushNotificationsService from '@core/services/pushNotifications/PushNotificationsService';
import { PushEventType } from '@core/services/pushNotifications/types';
import Payment from '@core/models/user/pushNotifications/Payment';
import { PaymentStatus } from '@walletFederation/src/modules/payments/enums';
import CopyCodeButton from '@walletFederation/src/components/CopyCodeButton.vue';
import QrCodeDetails from '@walletFederation/src/components/QrCodeDetails.vue';
import accountIndex from '@store/modules/ui/user/account/accountIndex';
import QrDepositSuccess from './QrDepositSuccess.vue';
import QrDepositError from './QrDepositError.vue';
import DepositError from '@core/errors/user/DepositError';
import { Cpf } from '@accountFederation/countries/com/registration/cpf';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import {
    processFinalDepositAnalytics,
    createTransactionDtoForQuickDeposit,
} from '@walletFederation/src/ui/deposit/components/DepositMethods';
import { OnlineDepositType } from '@core/mappers/transaction/types';
import { ModalCode } from '@walletFederation/src/modals/ModalCodes';
import { isBelgium } from '@modules/layout/utils/isCountry';
import { currentSite } from '@app/utils/domainHelpers';
import { Site } from '@superbet-group/web.types';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { Unsubscribe } from '@superbet-group/web.lib.feature-toggle-service';
import { captiveKycStore } from '@accountFederation/store/data/captiveKyc/captiveKycStore';

export default defineComponent({
    name: 'QrDepositForm',
    props: {
        onFormReset: {
            type: Function as PropType<() => void>,
            required: false,
            default: () => {},
        },
    },
    setup(props) {
        const { formatTwoDecimals } = useI18n();
        const isQrCodeLoading = ref(false);
        const isLoading = ref(false);
        const qrRef = ref<HTMLElement>();
        const depositValue = ref();
        const qrEndDate = ref<Date>();
        const { pushRoute, route } = useVueRouter();
        const limitsStore = useVuexStore<LimitsStore>('data/authentication');
        const getLimits = limitsStore.action('getLimits');
        const depositLimits = limitsStore.getter('depositLimits');
        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');
        const accountModule = useVuexStore<typeof accountIndex>('ui/user/account');
        const getBalance = accountModule.action('getBalance');
        const errorModule = useVuexStore<typeof errorIndex>('errors');
        const showError = errorModule.action('showError');
        const countryModule = useVuexStore<typeof countryIndex>('data/country');
        const countryConfig = countryModule.getter('config');
        const defaultDepositAmount = computed(() => countryConfig.value.deposit.onlineMin ? parseInt(countryConfig.value.deposit.onlineMin, 10) : null);
        const qrDepositConfig = shellLocalConfig.qrDeposit!;
        const paymentUrl = ref<string>('');
        const paymentStatus = ref<PaymentStatus>();
        const transactionId = ref<string>();
        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const user = authModule.getter('user');
        const userHasMadeDeposit = authModule.getter('userHasMadeDeposit');
        const setUserData = authModule.action('setUserData');
        const captiveKycModule = useVuexStore<typeof captiveKycStore>('data/captiveKyc');
        const hasIncompleteVerification = captiveKycModule.getter('hasIncompleteVerification');
        const showCaptiveKycEntry = captiveKycModule.action('showCaptiveKycEntry');
        const getCSSVariable = (varName: string) => {
            return getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
        };

        const defaultPixIdentifier = computed(() => Cpf.format(user.value?.identityDocuments?.[0]?.identifier || ''));
        const isMobile = computed(() => isMobileLayout());
        const shouldSendPaymentTypeMainFlag = ref(false);
        const shouldSendPaymentTypeDiceOnly = ref(false);
        const featureFlags = [
            {
                key: 'wallet.quick-deposit.send-payment-provider',
                ref: shouldSendPaymentTypeMainFlag,
            },
            {
                key: 'wallet.quick-deposit.send-payment-provider-dice',
                ref: shouldSendPaymentTypeDiceOnly,
            },
        ];
        let featureSubscriptionUnsubscribeFns: Unsubscribe[];

        const fields = ref<{
            amount: {
                value: null | number;
                validate: any[]
            }
            pixIdentifier: {
                value: undefined | string
            }
        }>({
            amount: {
                value: defaultDepositAmount.value,
                validate: [
                    isRequired,
                    min(parseInt(countryConfig.value.deposit.onlineMin, 10)),
                    max(parseInt(countryConfig.value.deposit.onlineMax, 10)),
                ],
            },
            pixIdentifier: {
                value: defaultPixIdentifier.value,
            },
        });
        const fieldErrors = ref({});

        function loadQrCodeGenerator() {
            const url = `${window.location.origin}/static/js/qr-code.js`;
            loadScript(url, 'qrCodeGenerator');
        }

        function openLimitsReachedModal() {
            setModal({
                code: modalCodes.limitReached,
                data: {
                    contentKey: 'pam.deposit.modal.limits.content',
                    depositAmount: fields.value.amount.value,
                },
            });
        }

        function clearQrCode() {
            qrEndDate.value = undefined;
            paymentStatus.value = undefined;
            transactionId.value = undefined;
            paymentUrl.value = '';
            if (qrRef.value) {
                qrRef.value.innerHTML = '';
            }
        }

        function closeForm() {
            clearQrCode();
            props.onFormReset();
            fields.value.amount.value = defaultDepositAmount.value;
        }

        function onSubmit() {
            if (hasIncompleteVerification.value) {
                showCaptiveKycEntry();
                return;
            }
            generateQrCode();
        }

        async function generateQrCode() {
            clearQrCode();
            isQrCodeLoading.value = true;
            await errorGuard(async () => {
                const { session, sessionId } = antiFraudService.getCurrentSession();
                const paymentType = isBelgium() ? OnlineDepositType.Bancontact : OnlineDepositType.Pix;
                const shouldSendPaymentType = (currentSite === Site.NapoleonDice && shouldSendPaymentTypeDiceOnly.value) || shouldSendPaymentTypeMainFlag.value;
                const primaryColor = getCSSVariable('--system-text-on-elevation-primary');
                const secondaryColor = getCSSVariable('--system-bg-elevation-layer-1');

                AnalyticsSDK.getInstance().log('Deposit_Attempt', {
                    amount: fields.value.amount.value!.toString(),
                    paymentType,
                });

                const { paymentUrl: paymentUrlValue, transactionId: transactionIdValue } = await UserService.getInstance().createDeposit(
                    fields.value.amount.value!,
                    false,
                    false,
                    undefined,
                    session,
                    sessionId,
                    true,
                    shouldSendPaymentType ? paymentType : null,
                );

                paymentUrl.value = paymentUrlValue;
                transactionId.value = transactionIdValue;
                qrEndDate.value = addMinutes(qrDepositConfig.durationInMinutes, new Date());

                if (qrRef.value) {
                    window.QrCreator.render(
                        {
                            text: paymentUrlValue,
                            radius: 0,
                            ecLevel: qrDepositConfig.ecLevel,
                            fill: primaryColor,
                            background: secondaryColor,
                            size: qrDepositConfig.qrCodeSize,
                        },
                        qrRef.value,
                    );
                }
            }, {
                onError: (error) => {
                    if (error instanceof ValidationError) {
                        fieldErrors.value = error.fieldErrors;
                    } else if (error instanceof LimitError && shellLocalConfig.deposit?.hasDepositLimitReachedModal) {
                        openLimitsReachedModal();
                        closeForm();
                    } else if (error instanceof DepositError && shellLocalConfig.hasImprovedDepositError) {
                        setModal({
                            code: ModalCode.depositError,
                            data: {
                                errorMessage: error.message,
                            },
                        });
                    } else {
                        showError(error);
                        closeForm();
                    }
                },
            });
            isQrCodeLoading.value = false;
        }

        function subscribeToUpdates() {
            PushNotificationsService.getInstance().subscribe(PushEventType.Payment, (payment: Payment) => {
                if (payment.status === PaymentStatus.Approved) {
                    errorGuard(() => getBalance({ showLoading: true }));
                    if (getConfig().countrySpecific.user.responsibleGaming?.depositLimitsProgress) {
                        errorGuard(() => getLimits());
                    }
                }

                if (!payment.paymentId || payment.paymentId !== transactionId.value) {
                    return;
                }

                if (qrDepositConfig.shouldShowModalOnCompletion) {
                    if (payment.status === PaymentStatus.Approved) {
                        setModal({
                            code: modalCodes.successModal,
                            isClosable: false,
                            title: 'wallet.deposit.modal.success.title',
                            data: {
                                illustrationPath: '/static/img/illustrations/deposit__success.svg',
                                translateKey: 'wallet.deposit.modal.success.text',
                                closeBtnKey: 'wallet.deposit.modal.success.btn',
                                closeHandler: () => {
                                    closeForm();
                                },
                            },
                        });
                    } else {
                        setModal({
                            code: modalCodes.successModal,
                            title: 'wallet.deposit.modal.error.title',
                            data: {
                                illustrationPath: '/static/img/illustrations/deposit__error.svg',
                                translateKey: 'wallet.deposit.modal.error.text',
                                closeBtnKey: 'wallet.deposit.modal.error.btn',
                                closeHandler: () => clearQrCode(),
                            },
                        });
                    }
                } else {
                    paymentStatus.value = payment.status;
                }

                processFinalDepositAnalytics(
                    createTransactionDtoForQuickDeposit(payment, fields.value.amount.value!),
                    user.value!,
                    userHasMadeDeposit.value,
                    () => {
                        setUserData({
                            key: 'hasMadeDeposit',
                            value: true,
                        });
                        setUserData({
                            key: 'firstDepositDate',
                            value: Date.now(),
                        });
                    },
                );
            });
        }

        const amounts = computed(() => {
            return countryConfig.value.deposit.quickAmounts.map((amount: number) => ({
                type: amount,
                displayName: amount,
            })) as TypeItem[];
        });

        onMounted(() => {
            subscribeToUpdates();

            featureSubscriptionUnsubscribeFns = featureFlags.map(({ key, ref }) => {
                const flagRef = ref;
                return featureFlagService.subscribeToFeatureChanges(key, (value) => {
                    flagRef.value = value;
                }, false);
            });

            loadQrCodeGenerator();
            AnalyticsSDK.getInstance().log('Deposit_Intent');
        });
        onBeforeUnmount(() => {
            featureSubscriptionUnsubscribeFns.forEach((unsubscribeFn) => unsubscribeFn?.());
        });
        return {
            qrDepositConfig,
            depositValue,
            qrRef,
            paymentUrl,
            isQrCodeLoading,
            qrEndDate,
            fields,
            fieldErrors,
            depositLimits,
            isLoading,
            paymentStatus,
            PaymentStatus,
            formatTwoDecimals,
            isMobile,
            isGenerateQrCodeDisabled: computed(() => {
                if (isQrCodeLoading.value) {
                    return true;
                } else {
                    return !fields.value.amount.value;
                }
            }),
            shouldFillAmountDecimals: shellLocalConfig.hasEnforcedAmountDecimals,
            amounts,
            onSubmit,
            clearQrCode,
            onAmountClick: (amount: number, amountChangedCb: (amout: number, name: string) => void) => {
                fields.value.amount.value = amount;
                amountChangedCb(amount, 'amount');
                nextTick(() => {
                    const inputEl = depositValue.value.$el?.querySelector('input');
                    if (inputEl) {
                        inputEl.focus();
                    }
                });
            },
            openDepositPage: () => {
                closeForm();
                if (route.value.name !== RouteName.Account.Deposit) {
                    pushRoute({ name: RouteName.Account.Deposit });
                }
            },
        };
    },
    components: {
        SdsTypeSwitcher,
        SdsAlert,
        SdsButton,
        CopyCodeButton,
        QrCodeDetails,
        SdsInputCurrency,
        DepositLimitsProgress,
        QrDepositSuccess,
        QrDepositError,
    },
});
